<template>
  <div
    v-on-clickaway="clickAway"
    :class="classesRoot"
  >
    <div
      :class="$style.content"
      :style="contentStyle"
    >
      <div
        :class="$style.heading"
        @click="close"
      >
        <slot name="heading" />
      </div>

      <slot name="default" />

<!--      <div :class="$style.controls">-->
<!--        <a-->
<!--          :class="$style.buttonClose"-->
<!--          @click.prevent="close"-->
<!--        >-->
<!--          Закрыть-->
<!--        </a>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway';

  export default {
    name: 'CalendarLessonsDayDropdown',
    mixins: [clickaway],
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
      outline: {
        type: Boolean,
        default: false,
      },
      contentStyle: {
        type: Object,
        default: null,
      },
    },
    computed: {
      classesRoot() {
        const { $style } = this;
        return {
          [$style.root]: true,
          [$style.isOpened]: this.opened,
          [$style.isOutline]: this.outline,
        };
      },
    },
    methods: {
      clickAway() {
        if (!this.opened) return;
        this.close();
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" module>
  .root {
    max-height: 0;
    background-color: $colorWhite;
    border-radius: 10px;
    transition: $primaryTransition;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
    opacity: 0;
    overflow: hidden;
    width: 115%;

    &.isOpened {
      max-height: 700px;
      opacity: 1;
    }
  }

  .content {
    background-color: $colorWhite;
    border-radius: 2px;
    @include paddingX(10px);
    padding-bottom: 15px;
    @include typography(13px, 16px);
    font-weight: 500;
    text-align: center;

    .isOutline & {
      @include paddingX(8px);
      margin: 2px;
    }
  }

  .heading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    @include paddingX(2px);
    margin-bottom: 5px;
    white-space: nowrap;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 17px;
    .isOutline & {
      height: 40px;
    }
  }

  .date {
    margin-bottom: 15px;
  }

  .controls {
    margin-top: 15px;
  }

  .buttonClose {
    @extend %link;
    user-select: none;
  }
</style>
